import React, { useContext, useEffect } from 'react'
import Sidebar from '../Sidebar'
import MobileNavbar from '../MobileNavbar'
import TopBar from '../TopBar'
import Footer from '../Footer'
import MobileBottombar from '../MobileBottombar'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import LoginPopup from '../LoginPopup'
import LoginContext from '../../context'
import { handleApiResponse } from '../../utils/helpers'

const Layout = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { isAuthenticated, token, logout } = useContext(LoginContext)

    useEffect(() => {
        if (!isAuthenticated) return;

        const interval = setInterval(async () => {
            if (location.pathname === '/message') return;

            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/messages/unread-status`, {
                    headers: {
                        "accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token?.token}`,
                    }
                })
                const data = await handleApiResponse(response, logout);

                if (data.has_unread_messages) {
                    navigate('/message')
                }
            } catch (error) {
                console.error('Error checking unread messages:', error)
            }
        }, 30000) // 30 seconds

        return () => clearInterval(interval)
    }, [location.pathname, isAuthenticated, navigate])
    return (
        <>
            <Sidebar />
            <MobileNavbar />
            <div className='lg:ml-[300px] bg-black pt-[80px] lg:pt-0'>
                <TopBar />
                <Outlet />
                <Footer />
                <MobileBottombar />
            </div>
            <LoginPopup />
        </>
    )
}

export default Layout